import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const FeatureDetail = ({ title, content, alignment }) => {
  const titleStyle = `default-color mt3 f3-ns ${alignment}`
  const contentStyle = `default-color text-light mt2 f4-ns ${alignment}`
  return (
    <div>
      <div className={titleStyle}>
        <FormattedMessage id={title} />
      </div>
      <div className={contentStyle}>
        <FormattedMessage id={content} />
      </div>
    </div>
  )
}

FeatureDetail.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  alignment: PropTypes.string.isRequired,
}

export default FeatureDetail



// WEBPACK FOOTER //
// ./src/components/FeatureDetail.js